module.exports = __webpack_public_path__ + "static/media/kuro-videographer_ill.751aa55d.svg";